/*------Accessibility------ */
export const ENTER = 'Enter';
export const SPACE = ' ';

/*------Satisfaction Rating------ */
export const SATISFACTION_RATING_DELAY_3_MIN_MS = 3 * 60 * 1000; // 3 minutes
export const SATISFACTION_RATING_DELAY_30_SEC_MS = 30 * 1000; // 30 seconds
export const SATISFACTION_RATING_COMMENT_CHAR_LIMIT = 300;
export const SATISFACTION_RATING_COMMENT_THRESHOLD = 4; // Show comment textarea for ratings less than 4

/*------Intercom------ */
export const INTERCOM_LAUNCHER_CLASS = 'intercom-launcher';
export const INTERCOM_LAUNCHER_CLASS_MOBILE = 'intercom-launcher-mobile';

/*------Job Tools------ */
export const JobToolFeatureKey = {
  RESUME_REVIEW: 'resume-review',
  INTERVIEW_PREP: 'interview-prep',
  JOB_TRACKER: 'job-tracker',
  RESUME_GENERATOR: 'resume-generator',
  AI_COACH: 'ai-coach',
} as const;

export type JobToolFeatureKeyType =
  (typeof JobToolFeatureKey)[keyof typeof JobToolFeatureKey];
